/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more-info': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12 3.6a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8zM2.4 12a9.6 9.6 0 1119.2 0 9.6 9.6 0 01-19.2 0zm8.4-3.3c0-.497.4-.9.893-.9h.014c.493 0 .893.403.893.9s-.4.9-.893.9h-.014a.896.896 0 01-.893-.9zm.2 2.1a.6.6 0 000 1.2h.4v3.4a.6.6 0 00.6.6h1a.6.6 0 100-1.2h-.4v-3.4a.6.6 0 00-.6-.6h-1z" _fill="#1F222C"/>'
  }
})
